<template>
  <div class="user-list">
    <div class="user-list-title">
     
      <div class="left">
        <!-- 头部搜索查找 -->
      </div>
      <div class="right">
        <el-button type="primary" icon="el-icon-plus" @click="handleAddUser">添加用户</el-button>
      </div>
    </div>
    <div class="user-list-table">
      <el-table :data="tableData" style="width: 100%;">
        <el-table-column prop="roleId" label="序号">
        </el-table-column>
        <el-table-column prop="userId" label="用户id">
        </el-table-column>
        <el-table-column prop="userName" label="用户名" >
        </el-table-column>
        <el-table-column prop="realName" label="姓名">
        </el-table-column>
        
        <el-table-column prop="roleName"  label="角色">
        </el-table-column>
        <!-- <el-table-column prop="phone" width="180" label="电话"> 
        </el-table-column>-->
        <el-table-column label="操作">
          <template scope="scope">
            <div class="handle">
              <el-switch
                v-model="scope.row.active"
                @change="handleSwich(scope.row)"
                active-text="启用"
                >
              </el-switch>
              <span class="update" @click="handleUpdata(scope.row)"> 编辑 </span>
              <i class="el-icon-delete"  @click="handleDelete(scope.row)"></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
        <el-pagination
        class="pagination"
        :page-sizes="[10, 20, 30, 50, 100]"
        :current-page="initParams.page"
        :page-size="initParams.pageSize"
        :total="initParams.total"
        @prev-click="prevPage"
        @next-click="nextPage"
        layout="total, prev, pager, next"
        @current-change="handleCurrentChange"
      />
    </div>
    <updata-dialog
       v-if="updata&&roleOption"
      :isDialog="isDialog"
      :item="updata"
      :roleOption="roleOption"
      @handleCancel="handleCancel"
      @handleConfirm="handleConfirm"
      ></updata-dialog>
      <delete-dialog 
      v-if="dialogVisible"
      :dialogVisible="dialogVisible"
      :text="isText"
      @deleteConfirm="deleteConfirm"
      @deleteCancel="() => dialogVisible = false"
      >

      </delete-dialog>
      <!-- 添加 -->
      <add-dialog 
      v-if="addVisible&&roleOption"
      :addVisible="addVisible"
      :roleOption="roleOption"
      @addCancel="addCancel"
      @addConfirm="addConfirm"
      ></add-dialog>
  </div>
</template>

<script>
import { getUserList, getAddUser, getUpdataStatus, getUpdataUser, getDeleteUser } from "@/api/userAdmin";
import { getRoulList } from "@/api/roulAdmin"; // 获取角色列表
import UpdataDialog from "../components/UpdataDialog.vue";
import DeleteDialog from "@/components/DeleteDialog.vue";
import AddDialog from "../components/AddDialog.vue";
export default {
  data () {
    return {
      tableData: [ 
      //   {
      //   enableStatus: 1,
      //   phone: "",
      //   realName: "陈浩",
      //   remark: "",
      //   roleId: 3,
      //   active: true,
      //   roleName: "超级管理员",
      //   userId: 4,
      //   userName:"chenhao2"
      // }
    ],
      initParams:{
        page: 1,
        pageSize: 20,
        total: 0,
        totalPage: 0
      },
      isDialog: false,
      updata: null,
      dialogVisible: false,
      isText: '确定删除该用户吗？',
      delete: null,
      addVisible: false,
      // 角色列表
      roleOption: null
    }
  },
  components: {
    UpdataDialog,
    DeleteDialog,
    AddDialog
  },
  methods: {
    prevPage(){
      this.initParams.page>1 ? this.initParams.page --:this.initParams.page=1  
    },
    nextPage(){
      if( this.initParams.page < this.initParams.totalPage){
        this.initParams.page++
      }else{
        this.initParams.page = this.initParams.totalPage
      }
    },
    getList () {
      const keyword = {
        page: this.initParams.page,
        pageSize: this.initParams.pageSize 
      }
      getUserList(keyword).then(res => {
        if(res.data){
          res.data.dataList = res.data.dataList.map(item => {
            if(item.enableStatus){
              item.active = true;
            }else{
              item.active = false;
            }
            return item
          })
          this.tableData = res.data.dataList;
          this.initParams.total = res.data.total;
          this.initParams.totalPage = res.data.totalPage
        }
      })
    },
    getRoulListFun(){
      // 获取角色列表
      getRoulList({}).then(res => {
        if(res.data){
          this.roleOption = res.data.dataList;
        }
      })
    },
    handleSwich(item){
      const params = {
        userId: item.userId,
        enableStatus: item.active?1:0
      }
      getUpdataStatus(params).then(res => {
        if(res.code === '0'){
          this.$message({
            message:  `${item.active?'启用':'取消启用'}成功`,
            type: 'success'
          });
        }
      })
    },
    // 编辑
    handleUpdata(item){
      this.updata = item
      this.isDialog = true;
      this.getRoulListFun()
    },
    // 取消编辑
    handleCancel(val){
      this.isDialog = val;
      this.updata = null
    },
    // 确定修改
    handleConfirm(val){
      // 请求修改接口
      getUpdataUser(val).then(res => {
        if(res.code === '0'){
          this.$message({
            message: "修改成功",
            type: 'success'
          });
          this.isDialog = false;
          this.updata = null;
        }
      })
    },
    // 删除
    handleDelete(item){
      this.delete = item;
      this.dialogVisible = true
    },
    // 确定删除
    deleteConfirm(){
      // 点击确定删除；请求接口
     
      getDeleteUser(this.delete.userId).then(res => {
        if(res.code === "0"){
          this.$message({
            message: "删除成功",
            type: 'success'
          });
          this.delete = null;
          this.dialogVisible = false
        }
        this.getList()
      })
    },
    // 添加
    handleAddUser(){
      this.getRoulListFun()
      this.addVisible = true;
    },
    // 确定添加
    addConfirm(val){
      // 请求添加接口
      getAddUser(val).then(res => {
        if(res.code === '0'){
          this.$message({
          message: '添加成功',
          type: 'success'
        });
        this.addVisible = false;
        this.roleOption = null
        this.getList();
        }
      })
    },
    // 取消添加
    addCancel(){
      this.addVisible = false;
        this.roleOption = null
    },
    // 分页
    // handleSizeChange(){
    //   console.log(123)
    // },
    handleCurrentChange(val){
      this.initParams.page = val;
      this.getList()
    }
  },
  mounted () {
    // this.getList()
  }
}
</script>

<style lang="scss" scoped>
.user-list {
  width: 100%;
  height: 100%;
  &-title {
    min-height: 50px;
    max-height: 100px;
    background: #fff;
    .left{
      float: left;
    }
    .right{
      float: right;
    }
  }
  /deep/ .el-table__row{
    .handle{
      .update{
        margin:0 20px;
      }
      .el-switch, .update, .el-icon-delete{
        cursor: pointer;
      }
    }
  }
  /deep/ .pagination{
    width: 100%;
    background: #fff;
    position: absolute;
    right: 0;
    bottom: -25px;
  }
}

</style>